import { UserRpps } from '@saas/interfaces/core'
import { getIdsAnnDirectoryPhysicianRppsRppsProfessionCodeProfession } from '@toktokdoctech/tokapi-client'
import { RequesterData } from '../components/Requester/_props'
import { defaultRppsData } from '../components/Requester/utils/_utils'
import { UseRequesterRppsProps } from './_props'

export const useRequesterRpps = ({ resetForm, update }: UseRequesterRppsProps) => {

    const loadRpps = async (value: string | UserRpps | null) => {
        if (!value || typeof value === 'string') {
            resetForm(defaultRppsData)
            update({ isLoading: false })
            return undefined
        }

        update({ isLoading: true, loaderMessage: 'Vérification des données...' })

        const annUser = await getIdsAnnDirectoryPhysicianRppsRppsProfessionCodeProfession(
            String(value.identifiantpp),
            String(value.codeprofession),
        )

        update({ loaderMessage: "Chargement des données via l'annuaire santé" })

        const result: Partial<RequesterData> = {
            rppsNum: value.identifiantpp.toString(),
            lastName: annUser?.nomdexercice,
            firstName: annUser?.prenomdexercice,
            nationalId: annUser?.userIdnps,
            profession: {
                code: annUser?.codeprofession || '',
                label: annUser?.profession?.name || '',
            },
            speciality: {
                code: annUser?.codesavoirfaire || '',
                label: annUser?.speciality?.name || '',
            },
            securedEmailList: annUser?.mssEmails ?? [],
        }

        resetForm(result)
        update({ isLoading: false, loaderMessage: undefined })
        return result
    }

    return { loadRpps }
}
